<template>
    <div class="brand">
        <LinkTitle title="titles.brand"/>
        <div class="brand-content">
            <p> 
                {{ $t(brandText) }}

            </p>
        </div>
    </div>
</template>

<script>
import LinkTitle from '@/components/LinkTitle.vue';
export default {
    name: 'Brand',
    components: {
        LinkTitle
    },
    data(){
        return {
            brandText: 'brand.text'}
    }
}
</script>

<style scoped>
.brand-content {
    text-indent: 2em;
    width: 86%;
    margin: 0 auto;
    background-color: #f6f5f5;
    padding: 1vw;
    line-height: 2em;
    border-radius: .3vw;
}

@media screen and (max-width: 940px) {
    .brand-content {
    text-indent: 2em;
    width: 90%;
    margin: 0 auto;
    background-color: #f6f5f5;
    padding: 1vw;
    line-height: 2em;
    border-radius: .3vw;
    font-size: 2vw;
    letter-spacing: 0.1vw;
    font-weight: bold;
    }
}


</style>
